import { Head } from '@inertiajs/react'

import AdminLayout from '@/components/layouts/AdminLayout'
import { PageHeader } from '@/components/patterns'
import { ActivityLogFilterBar } from '@/components/activity_logs/ActivityLogFilterBar'
import { ActivityLogTable } from '@/components/activity_logs/ActivityLogTable'
import type {
  ActivityLog,
  ActivityLogFilterOptions,
  ActivityLogFilters,
  ActivityLogPagination,
} from '@/components/activity_logs/types'

const BASE_PATH = '/admin/activity_logs'

interface AdminActivityLogsProps {
  logs: ActivityLog[]
  pagination: ActivityLogPagination
  filters: ActivityLogFilters
  filter_options: ActivityLogFilterOptions
}

/**
 * Platform-wide activity trail (global admins only — `ensure_global_admin!`).
 * Rows here span every event plus the detached ones, so this is the surface that
 * gets both the event column and the event filter.
 */
export default function AdminActivityLogsPage({
  logs,
  pagination,
  filters,
  filter_options,
}: AdminActivityLogsProps) {
  return (
    <AdminLayout>
      <Head title="Activity Logs" />

      <div className="w-full bg-[#f5f5f5]">
        <PageHeader
          title="Activity Logs"
          description="Every recorded action across the platform — who did it, from where, and what changed."
        />

        <div className="flex flex-col gap-4 p-6">
          <ActivityLogFilterBar
            basePath={BASE_PATH}
            filters={filters}
            filterOptions={filter_options}
            perPage={pagination.per_page}
            showEventFilter
          />

          <div className="rounded-lg bg-white p-4">
            <ActivityLogTable
              logs={logs}
              pagination={pagination}
              filters={filters}
              basePath={BASE_PATH}
              showEventColumn
            />
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
